module.exports = __webpack_public_path__ + "static/media/jJPY.e82dc650.png";